import { Component, OnInit, Inject } from '@angular/core';
import {ReportsService} from './reports.service';
import {AppService} from '../shared/services/app.service';

@Component({
  selector: 'app-hcustomer',
  templateUrl: './hcustomer.component.html'
})
export class HcustomerComponent implements OnInit {

  results:any[];

  constructor(
    private _reportsService: ReportsService,
    private _appService: AppService
  ){

  }

  ngOnInit() {
    this._appService.showLoader();
    this.getReport();
  }

  getReport() {
    this._reportsService.getHcustomers().subscribe(
      data => this.results = data.results,
      error => console.log(error),
      () => {
        this._appService.hideLoader();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/hcustomer.component.ts